import AutocompleteFormComponent from "components/shared/FormComponent/AutocompleteFormComponent";
import StyledButton from "components/shared/StyledButton";
import { useTranslation } from "react-i18next";
import { IBrand } from "store/brandStore";

import styles from "./style.module.scss";

interface IBrandAccountingCode {
    companyBrands: string[];
    setBrandChosen: any;
    handleAddAccountBrand: any;
}

const AddBrandAccountingCode = ({ companyBrands, setBrandChosen, handleAddAccountBrand }: IBrandAccountingCode) => {
    const [t] = useTranslation();

    return (
        <div className={styles["brand-code-modal"]}>
            <h3 className={styles["modal-info"]}>{t("BrandAccountingCode.ModalInfo")}</h3>
            <AutocompleteFormComponent
                options={companyBrands}
                renderOptionText={(option) => `${option.name}`}
                onChange={(e: any, value) => setBrandChosen(value)}
                className={styles["brand-autocomplete"]}
                placeholder={t("BrandAccountingCode.ChooseBrand")}
            />
            <StyledButton onClick={() => handleAddAccountBrand()} buttonType="primary" fullWidth>
                {t("NewTitle.Validate")}
            </StyledButton>
        </div>
    );
};

export default AddBrandAccountingCode;
